var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"echarts-pie-box"},[_c('p',{staticClass:"echarts-pie-title",attrs:{"title":_vm.title}},[_vm._v(_vm._s(_vm.title))]),_c('div',{ref:"echart",staticClass:"echarts-pie-wrap"})])
}
var staticRenderFns = []

export { render, staticRenderFns }